module.exports = {
  findPwd: {
    find: 'Сбросить пароль',
    userName: 'Телефон или адрес эл.почты',
    error_userName_1: 'Введите номер телефона или адрес эл.почты',
    error_userName_2: 'Пользователь не зарегистрирован',
    get_code: 'Отправить код',
    get_code_tip: 'Нажмите для отправки кода',
    get_code_tip_re: 'сек. ',
    code: 'Код',
    error_code_1: 'Введите проверочный код',
    error_code_2: 'Исчерпан дневной лимит на отправку 5 проверочных кодов',
    error_code_3: 'Ошибка в коде',
    next: 'Продолжить',
    input_password: 'Пароль',
    repeat_new_password: 'Подтвердите пароль',
    new_password_error: 'Пароль подтверждения не совпадает с основным паролем',
    submit_new_password: 'Сменить пароль',
    success_relogin: 'Новый пароль успешно установлен',
    button_relogin: 'Войти снова'
  },
  register: {
    register: 'Регистрация в CZUR',
    phone_register: 'Моб.телефон',
    email_register: 'Эл.почта',
    phone: 'Введите номер моб.телефона',
    error_phone: 'Неверный номер телефона',
    already_bound: 'Пользователь уже зарегистрирован',
    not_support: 'Канал связи не поддерживается',
    code: 'Проверочный код',
    code_error: 'Неверный проверочный код',
    get_code: 'Отправить код',
    get_code_tip_re: 'сек. ',
    error_code_1: 'Поле кода подтверждения не может быть пустым',
    error_code_2: 'Исчерпан дневной лимит на отправку 5 проверочных кодов',
    error_code_3: 'Ошибка в проверочном коде',
    error_code_4: 'Отправленный код подтверждения действует 10 мин., нет необходимости повторной отправки',
    error_code_5: 'Пожалуйста, не запрашивайте проверочный код слишком часто',
    password_set: 'Пароль из 8-20 букв и цифр',
    password_error_1: 'Поле пароля не может быть пустым',
    protocol_a: 'Я прочитал ',
    protocol_b: 'пользовательские условия',
    submit: 'Создать аккаунт',
    login_now: 'Войти здесь',
    success: 'Поздравляем с успешной активацией аккаунта CZUR! Для входа в аккаунт, пожалуйста, авторизуйтесь.',
    login_re: 'Вернуться для повторного входа',
    email: 'Введите адрес эл.почты',
    email_error: 'Неверный формат эл.почты',
    email_already_bound: 'Пользователь уже зарегистрирован',
    accout_safe_tips: 'Пожалуйста, свяжите ваш аккаунт с телефоном для дополнительной безопасности',
    password_repeat: 'Повторите пароль (6-20 символов)',
    bind: 'Связать',
    password: 'Установить пароль'
  },
  success: {
    activation: 'Отправлено',
    activation_email: 'Письмо с подтверждением отправлено на ваш почтовый ящик *, ',
    click_email: 'нажмите на ссылку в письме для завершения регистрации.',
    active_email: 'Что делать, если письмо с подтверждением не получено или ссылка устарела?',
    email_help1: '● Убедитесь, что письмо не попало в Спам и не было удалено.',
    email_help2: '● Отправьте повторно.',
    activation_success: 'Поздравляем с успешной активацией аккаунта CZUR! Для входа в аккаунт, пожалуйста, авторизуйтесь.',
    jumping_now: 'Далее',
    activation_failed: 'Устаревшая ссылка',
    valueText: 'Нажмите для повторной отправки',
    jumpingText: 'Переход (',
    get_code_tip_re: 'сек. ',
    code_error1: 'Всего 5 попыток',
    code_error2: 'Не удалось отправить'
  },
  index: {
    loginText: 'Войти',
    userName: 'Телефон или адрес эл.почты',
    password: 'Пароль',
    forgetPwd: 'Забыли пароль?',
    register: 'Создать аккаунт',
    userTip: 'Введите номер телефона или адрес эл.почты',
    pwdTip: 'Введите пароль',
    loginFail: 'Неверное имя пользователя или пароль',
    errorFormat: 'Неверный формат',
    inactive: 'Письмо для активации отправлено на ваш почтовый ящик',
    resend: 'Нажмите для повторной отправки',
    success: 'Успешно',
    info: 'Аккаунт-центр'
  },
  basic: {
  	editText: 'Изменить',
  	updateText: 'Обновить',
  	logoutText: 'Выйти',
  	czurId: 'CZUR ID',
  	emailBind: 'Почтовый ящик',
  	phone: 'Резервный номер телефона',
  	password: 'Пароль',
  	passwordSet: '(Отправлено)',
  	bindText: 'Связать',
    unbindText: '(Отвязать)',
  	navText: 'Персональный центр',
  	emailAddress: 'Адрес эл.почты',
  	emailEmpty: 'Введите адрес эл.почты',
  	emailInvalid: 'Неверный адрес эл.почты',
  	emailBinds: 'Указанный адрес эл.почты уже привязан к другому аккаунту',
  	codeEmpty: 'Введите код подтверждения',
  	codeError: 'Неверный код подтверждения',
  	fiveTimes: 'С одного почтового ящика можно отправить не более 5 кодов в день',
  	hasSent: 'Код подтверждения выслан, время действия кода - 10 мин.',
  	highFrequency: 'Пожалуйста, не запрашивайте проверочный код слишком часто',
  	emailCode: 'Отправить код подтверждения по эл.почте',
  	emailSend: 'Отправить код',
  	Submit: 'Отправить',
  	sendAgain: 'сек. ',
  	validateEmail: 'Подтвердить адрес эл.почты',
  	emailSent: 'Код подтверждения выслан на почтовый ящик ',
  	nextStep: 'Далее',
  	successText: 'Успешно изменено',
  	finishText: 'Завершить',
  	updatePwd: 'Сменить пароль',
  	oldPwd: 'Текущий пароль',
  	newPwd: 'Новый пароль',
  	confirmPwd: 'Подтвердить новый пароль',
  	oldPwdInput: 'Введите текущий пароль',
  	newPwdInput: 'Введите новый пароль',
  	notSame: 'Новый пароль не может совпадать с текущим паролем',
  	confirmPwdInput: 'Введите пароль подтверждения',
  	notSameWith: 'Новый пароль не соответствует паролю подтверждения',
  	oldPwdInvalidate: 'Исходный пароль недействителен ',
  	notExist: 'Пользователь не зарегистрирован',
  	fiveTime: 'С одного номера телефона можно отправить не более 5 кодов в день',
  	validatePhone: 'Подтвердить номер телефона',
  	phoneSent: 'Код подтверждения отправлен на телефон',
  	phoneCode: 'SMS код подтверждения',
  	phoneInput: 'Введите номер моб.телефона',
    error_phone: 'Неверный номер телефона',
    already_bound: 'Пользователь уже зарегистрирован',
    bindPhone: 'Привязать телефон',
    phoneNum: 'Номер телефона',
    uploadImg: 'Загрузить изображение',
    supportText: 'Поддерживаются только JPG и PNG форматы, размер файла не более 200 КБ',
    confirm: 'Подтвердить',
    cancel: 'Отменить',
    nicknameLong: 'Пожалуйста, введите никнейм в пределах 14 символов',
    closeAcount: 'Выйти',
    nicknameEmpty: 'имя не может быть пустым',
    nicknameEmoji: 'Использование специальных символов или смайликов не допускается.',
    area: 'область',
    closeHint: 'добрые советы',
    closeText: 'Учетная запись Chengzhe Cloud является общей учетной записью Chengzhe CZUR, Minimalist Scanner, Chengzhe Minimalist Scanner, Starry Meeting и Scanner. Операция отмены приведет к отмене всех вышеуказанных учетных записей, пожалуйста, подтвердите внимательно. ',
    closeWarning: 'После удаления учетной записи все пользовательские данные будут уничтожены, пожалуйста, действуйте с осторожностью! ',
    close: 'выйти',
    code: 'Проверочный код',
    slelctCountry: 'Выберите регион',
    lowPw: 'Ваш пароль слишком простой, вы должны изменить пароль, прежде чем продолжить',
    logout: 'покидать'
  },
  titleText: {
    account_center: 'Центр аккаунтов',
    privacy: 'политика конфиденциальности - CZUR',
    create_account: 'Создать учетную запись - CZUR',
    terms_service: 'условия обслуживания - CZUR',
    find_pwd: 'Найти пароль - CZUR',
    active: 'активный - CZUR',
    account_CZUR: 'Центр аккаунтов - CZUR'
  }
}



// WEBPACK FOOTER //
// ./src/common/lang/ru.js